<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » メール送信本文ダイアログの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>メール送信本文ダイアログの説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/send-mail-message-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> メール送信本文（メイン言語）
        </div>
        <div class="manual-explain">
          メール送信本文を設定します。<br>
          ユーザー予約が完了した時に送信されるメールの本文に利用されます。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> メール送信本文（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用のメール送信本文を設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> メール送信本文（他言語）
        </div>
        <div class="manual-explain">
          メール送信本文を設定します。<br>
          自動翻訳にチェックを入れることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Home</a> » Email Content Dialog Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Email Content Dialog Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_send-mail-message-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button closes the dialog.<br>
          Any changes made will not be applied.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Automatic Translation for All Languages
        </div>
        <div class="manual-explain">
          Toggles the automatic translation checkbox for all languages ON/OFF.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Email Content (Main Language)
        </div>
        <div class="manual-explain">
          Sets the email content.<br>
          This is used in the email sent when a user's reservation is completed.<br>
          The first language set in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> becomes the main language.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Email Content (For Translation)
        </div>
        <div class="manual-explain">
          Sets the email content for automatic translation.<br>
          The content set here will be used to translate into other languages.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Email Content (Other Languages)
        </div>
        <div class="manual-explain">
          Sets the email content for other languages.<br>
          Enabling automatic translation will execute the translation process (the content will be overwritten by the translation).
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button applies the changes made.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>